import { Component, Input } from '@angular/core';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';

@Component({
  selector: 'app-stock-filter',
    templateUrl: './stock-filter.component.html',
  standalone: false
})
export class StockFilterComponent{
    @Input() data: any;

    constructor(private uds: UserDefaultService) {
        this.uds.getDefaultStockCategory().subscribe(res => {
            if (res?.code) {
                this.data.stockCategoryFrom = res.code;
                this.data.stockCategoryTo = res.code;
            }
        });
        this.uds.getDefaultStockGroup().subscribe(res => {
            if (res?.code) {
                this.data.stockGroupFrom = res.code;
                this.data.stockGroupTo = res.code;
            }
        });
        this.uds.getDefaultStockClass().subscribe(res => {
            if (res?.code) {
                this.data.stockClassFrom = res.code;
                this.data.stockClassTo = res.code;
            }
        });
    }
}
